import { render, staticRenderFns } from "./ExamEditTabInformation.vue?vue&type=template&id=aa2757ea"
import script from "./ExamEditTabInformation.vue?vue&type=script&lang=js"
export * from "./ExamEditTabInformation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports